$(document).ready(function () {
    let howDoesIyarnWorkSlider = document.getElementById('howIyarnWork');
    if (howDoesIyarnWorkSlider === null) {
        return;
    }

    let videos = document.querySelectorAll("#howIyarnWork video");
    let videoIndexToPlay = 0;

    videos.forEach(function (video) {
        video.onended = (event) => {
            videoIndexToPlay++;
            if (videoIndexToPlay === visibleSlides) videoIndexToPlay = 0;

            videos[videoIndexToPlay].play();
        }
    });

    const elementIsVisibleInViewport = (el, gap = 0) => {
        let {top} = el.getBoundingClientRect();
        top += gap;
        const {innerHeight, innerWidth} = window;
        return (top > 0 && top < innerHeight);
    };

    let visibleSlides = calculateVisibleSlides();

    let howIyarnWorkSlider = new Swiper("#howIyarnWork", {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
            el: "#howIyarnWork .swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            576: {
                slidesPerView: "auto",
            },
        },
        slideFullyVisibleClass: 'slide-fully-visible',
        watchSlidesProgress: true,
        on: {
            slideChange: (swiper) => {
                if (visibleSlides === 1) {
                    pauseAllVideos(videos);
                    videos[swiper.activeIndex].play();
                }
            }
        }
    });

    window.addEventListener("resize", function () {
        visibleSlides = calculateVisibleSlides();

        if (visibleSlides === 1) {
            pauseAllVideos(videos);
            videoIndexToPlay = 0;
            videos[videoIndexToPlay].play();
            howIyarnWorkSlider.slideTo(0);
        }
    });

    let timer;
    $(window).scroll(function () {
        if (timer) {
            window.clearTimeout(timer);
        }
        timer = window.setTimeout(function () {
            pauseAllVideos(videos);

            if (elementIsVisibleInViewport(howDoesIyarnWorkSlider, 300)) {
                videos[videoIndexToPlay].play();
                window.clearTimeout(timer);
            } else {
                window.clearTimeout(timer);
            }
        }, 100);
    });

    function pauseAllVideos(videos) {
        videos.forEach(function (video, index) {
            videos[index].pause();
        })
    }

    function calculateVisibleSlides() {
        let visibleSlides = 3;
        if (window.innerWidth < 1100) {
            visibleSlides = 2;
        }
        if (window.innerWidth < 720) {
            visibleSlides = 1;
        }

        return visibleSlides;
    }
});
